import React, {FC, useCallback} from "react";
import styles from "./TableResumeView.module.scss";
import {SharedExtractControl, UserOrderControl} from "../../../models/table/ITableExtract";
import {useTablePayment} from "../../../context/tablePayment/TablePaymentContext";
import { TableResumeUserRow } from "./checkboxRows/TableResumeCheckboxRows";
import {Checkbox} from "@material-ui/core";
import {PaymentType} from "../../../models/payment/IPay";
import { moneyMaskNumber } from "utils/mask/money";

export const TableResumeView: FC = () => {
    const {
        extractsToPay,
        updateExtractToPay,
        sharedExtracts,
        totalFee,
        setTotalFee,
        updateTotalWithFee,
        updatePaymentMethod
    } = useTablePayment();

    const handleToggleServiceFee = (checked: boolean) => {
        if (!sharedExtracts?.command.totalFee) {
            return;
        }
        setTotalFee(checked ? sharedExtracts?.command.totalFee : 0);
        updateTotalWithFee(checked ? sharedExtracts?.command.totalFee : 0);
        updatePaymentMethod(PaymentType.NAO_INFORMADO);
    };

    const toggleUser = useCallback((extract: SharedExtractControl, checked: boolean) => {
        const updatedOrders = (extract.userOrders || []).map((o) => ({...o, checked}));
        updateExtractToPay({
            ...extract,
            userOrders: updatedOrders,
        });
    }, [updateExtractToPay]);

    const toggleOrder = useCallback((order: UserOrderControl, extract: SharedExtractControl, checked: boolean) => {
        const updatedOrders = (extract.userOrders || [])
            .map((o) => o.productName === order.productName ? {
                ...o, checked
            } : o);
        updateExtractToPay({
            ...extract, userOrders: updatedOrders,
        });
    }, [updateExtractToPay]);

    const handleQuantityChange = useCallback((order: UserOrderControl, newValue: number, extract: SharedExtractControl) => {
        const updatedOrders = (extract.userOrders || [])
            .map((o) => o.productName === order.productName ? {
                ...o, quantity: newValue
            } : o);
        updateExtractToPay({
            ...extract, userOrders: updatedOrders,
        });
        updatePaymentMethod(PaymentType.NAO_INFORMADO);
    }, [updateExtractToPay]);

    const hasFee = useCallback(() => {
        if (!sharedExtracts || !sharedExtracts?.command.totalFee) {
            return false;
        }
        return Number(sharedExtracts?.command.totalFee) > 0;
    }, [sharedExtracts]);

    return (<div className={styles.container}>
        <div className={styles.title}>Resumo</div>
        <hr/>
        <div className={styles.detailsContainer}>
            {extractsToPay && extractsToPay.length > 0 && (extractsToPay.map((extract, idx) => {
                return (
                    <TableResumeUserRow
                        key={extract.userData.phoneNumber}
                        extract={extract}
                        index={idx}
                        onToggleUser={toggleUser}
                        onToggleOrder={toggleOrder}
                        onHandleQuantityChange={handleQuantityChange}
                    />
                );
            }))}
        </div>
        {hasFee() && (
            <div className={styles.detailsContainer}>
                <div className={styles.resumeFee}>
                    <Checkbox
                        checked={!!totalFee}
                        onChange={(e) => handleToggleServiceFee(e.target.checked)}
                        color="secondary"
                    />
                    <span className={styles.productName}>
                                Taxa de serviço
                            </span>
                    <span className={styles.productPrice}>
                        {moneyMaskNumber(sharedExtracts?.command.totalFee ?? 0)}
                    </span>
                </div>
            </div>
        )}
    </div>);
};
